<template>
  <section class="f-21">
    <EndTitle class="title" v-ia />
    <div class="video_frame" v-ia>
      <m-video
        ref="video"
        class="video f-select-center"
        muted
        disablepictureinpicture
        playsinline
        webkit-playsinline
        poster="@/v2/auto/assets/video/20/poster/0.jpg"
        src="@/v2/auto/assets/video/20/0.mp4"
      />
      <replay @click="replayVideo($refs.video)" />
    </div>
    <Kpi class="kpi" v-ia />
  </section>
</template>
<script>
import EndTitle from '@/v2/auto/assets/image/20/end_title.vue'
import { replayVideo, videoPlayByVisibleArea } from '@/utils'
import replay from '@/components/replay.vue'
import Kpi from '@/v2/pad_auto/assets/images/kpi.vue'
export default {
  components: {
    replay,
    EndTitle,
    Kpi,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    videoPlayByVisibleArea(this.$refs.video)
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.f-21 {
  width: 100%;
  background-color: rgb(0, 0, 0);
  position: relative;
  z-index: 79;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    height: 4.8rem;
    max-height: 120px;
    min-height: 80px;
  }
  .video_frame {
    margin-top: 20px;
    width: min-content;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 20px;
    color: white;
    .video {
      border-radius: 24px;
      object-fit: cover;
      display: block;
    }
  }
  .kpi {
    width: 40%;
  }
}
</style>
